<template>
  <div class="hand-list">
    <template v-for="(item, index) in handleList">
      <div class="hend-item" v-if="item" :key="index" @click="item.click">
        <img class="icon" :src="item.icon" v-if="item.icon" />
        <span class="num">{{ item.num }}</span>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {
          likeState: false,
          like_num: 0,
          comment_num: 0,
          share_num: 0,
          day: ''
        }
      }
    },
    show: {
      type: Object,
      default() {
        return {
          like: true,
          day: true,
          comment: true,
          share: true
        }
      }
    }
  },
  components: {},
  data() {
    return {}
  },
  computed: {
    // 操作列表
    handleList() {
      let arr = [
        this.show.share
          ? {
              type: 'share',
              icon: require('../../../../images/platform/topicDetail/icon-share.png'),
              num: +this.info.share_num || '分享',
              click: () => {
                this.$emit('share')
              }
            }
          : null,
        this.show.comment
          ? {
              type: 'goComment',
              icon: require('../../../../images/platform/topicDetail/icon-huifu.png'),
              num: +this.info.comment_num || '评论',
              click: () => {
                this.$emit('goComment')
              }
            }
          : null,
        this.show.like
          ? {
              type: 'setLike',
              icon: this.info.likeState
                ? require('../../../../images/platform/dynamicDetail/icon-zan-seteted.png')
                : require('../../../../images/platform/topicDetail/icon-zan.png'),
              num: +this.info.like_num || '赞',
              click: () => {
                this.$emit('setLike')
              }
            }
          : null,
        this.show.day
          ? {
              type: 'day',
              icon: '',
              num: this.info.day,
              click: () => {}
            }
          : null
      ]
      return arr
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.hand-list {
  margin-top: 30px;
  display: flex;
  .hend-item {
    display: flex;
    align-items: center;
    .icon {
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }
    .num {
      font-size: 24px;
      font-weight: 400;
      color: #9da3ac;
      line-height: 24px;
    }
    &:not(:first-child) {
      margin-left: 100px;
    }
    &:last-child {
      margin-left: auto;
    }
  }
}
</style>
